/* assets/armonia-rte.js
   Pulizia automatica dei testi incollati (descrizione prodotto, cura, ecc.).
   Chi carica i prodotti copia spesso dal sito del brand/Word e si porta dietro stili,
   font, colori, <span>, <div> e righe vuote. Qui teniamo SOLO la struttura utile e
   buttiamo tutto il resto: il tema applica poi il suo stile.
   Si attiva sugli elementi con l'attributo data-armonia-rte.
   Mantiene: paragrafi, titoletti (h2-h4), elenchi, grassetto, corsivo, link, tabelle, immagini (solo del sito o del CDN Shopify), a capo.
   Toglie: style, class, id, font, colori, span, div inutili, righe vuote, &nbsp;, script, iframe.
   Per riusarlo da altro codice: Armonia.cleanRte(elemento). */
(function () {
  'use strict';

  var A = (window.Armonia = window.Armonia || {});

  var KEEP = {
    P: 1, BR: 1, UL: 1, OL: 1, LI: 1, STRONG: 1, EM: 1, A: 1, H2: 1, H3: 1, H4: 1,
    TABLE: 1, THEAD: 1, TBODY: 1, TR: 1, TH: 1, TD: 1, IMG: 1, SUB: 1, SUP: 1, BLOCKQUOTE: 1
  };
  var RENAME = { B: 'STRONG', I: 'EM', H1: 'H2', H5: 'H4', H6: 'H4', DIR: 'UL', MENU: 'UL' };
  var DROP = {
    SCRIPT: 1, STYLE: 1, IFRAME: 1, OBJECT: 1, EMBED: 1, FORM: 1, INPUT: 1, BUTTON: 1,
    SELECT: 1, TEXTAREA: 1, SVG: 1, LINK: 1, META: 1, NOSCRIPT: 1, VIDEO: 1, AUDIO: 1, CANVAS: 1
  };
  var BLOCK = {
    P: 1, UL: 1, OL: 1, LI: 1, H2: 1, H3: 1, H4: 1, TABLE: 1, THEAD: 1, TBODY: 1, TR: 1, TH: 1, TD: 1,
    BLOCKQUOTE: 1, DIV: 1, SECTION: 1, ARTICLE: 1, HEADER: 1, FOOTER: 1, MAIN: 1, ASIDE: 1,
    H1: 1, H5: 1, H6: 1, PRE: 1, FIGURE: 1, FIGCAPTION: 1, DL: 1, DT: 1, DD: 1, HR: 1,
    TFOOT: 1, CAPTION: 1, COLGROUP: 1, COL: 1
  };

  function safeHref(v) {
    v = (v || '').trim();
    if (!v) return '';
    if (/^(https?:|mailto:|tel:|\/|#)/i.test(v)) return v;
    if (/^[a-z][a-z0-9+.-]*:/i.test(v)) return ''; /* javascript:, data: ecc. */
    return v;
  }

  /* Immagini: solo del sito stesso (percorsi relativi, dominio del negozio) o del CDN di Shopify.
     Quelle di altri siti vengono tolte: non controlliamo cosa servono (tracking, file che spariscono). */
  function safeImg(v) {
    var u;
    v = (v || '').trim();
    if (!v) return false;
    if (/^\/(?!\/)/.test(v)) return true; /* percorso relativo (non //host) */
    try { u = new URL(v, location.href); } catch (e) { return false; }
    if (u.protocol !== 'https:' && u.protocol !== 'http:') return false;
    return u.host === location.host || /(^|\.)(shopify\.com|shopifycdn\.com)$/i.test(u.hostname);
  }

  /* Copia "pulita" di un nodo dentro il frammento out */
  function clean(node, out, doc) {
    var i, c, tag, name, el, a;
    for (i = 0; i < node.childNodes.length; i++) {
      c = node.childNodes[i];
      if (c.nodeType === 3) {
        out.appendChild(doc.createTextNode(c.nodeValue.replace(/[ ​﻿]/g, ' ').replace(/\s+/g, ' ')));
        continue;
      }
      if (c.nodeType !== 1) continue;
      tag = c.tagName.toUpperCase();
      if (DROP[tag]) continue;
      name = RENAME[tag] || tag;
      if (!KEEP[name]) { /* span, font, div, u, section...: si tiene il contenuto, si butta il contenitore */
        if (BLOCK[tag] && !/^(LI|TD|TH|P|H2|H3|H4)$/.test(out.nodeName)) { /* un div "da blocco" diventa un paragrafo se dentro ha solo testo/inline */
          el = doc.createElement('p');
          clean(c, el, doc);
          if (hasBlock(el)) { while (el.firstChild) out.appendChild(el.firstChild); }
          else out.appendChild(el);
        } else {
          clean(c, out, doc);
        }
        continue;
      }
      if (name === 'A' && !safeHref(c.getAttribute('href'))) { clean(c, out, doc); continue; }
      el = doc.createElement(name.toLowerCase());
      if (name === 'A') {
        a = safeHref(c.getAttribute('href'));
        if (a) {
          el.setAttribute('href', a);
          if (/^https?:/i.test(a) && a.indexOf(location.host) === -1) el.setAttribute('rel', 'noopener');
        }
      } else if (name === 'IMG') {
        a = c.getAttribute('src') || c.getAttribute('data-src') || '';
        if (!safeImg(a)) continue;
        el.setAttribute('src', a);
        el.setAttribute('alt', c.getAttribute('alt') || '');
        el.setAttribute('loading', 'lazy');
      } else if (name === 'TD' || name === 'TH') {
        if (c.getAttribute('colspan')) el.setAttribute('colspan', parseInt(c.getAttribute('colspan'), 10) || 1);
        if (c.getAttribute('rowspan')) el.setAttribute('rowspan', parseInt(c.getAttribute('rowspan'), 10) || 1);
      }
      if (name !== 'IMG' && name !== 'BR') clean(c, el, doc);
      out.appendChild(el);
    }
  }

  function hasBlock(el) {
    var i, t;
    for (i = 0; i < el.childNodes.length; i++) {
      t = el.childNodes[i].nodeType === 1 ? el.childNodes[i].tagName.toUpperCase() : '';
      if (t && BLOCK[t]) return true;
    }
    return false;
  }

  function isEmpty(el) {
    if (el.querySelector('img, table')) return false;
    return !el.textContent.replace(/[\s ]+/g, '');
  }

  /* Toglie elementi vuoti, spazi doppi e <br> a inizio/fine; ripete finché non cambia nulla */
  function tidy(root) {
    var changed = true, list, i, el, p, n;
    while (changed) {
      changed = false;
      list = root.querySelectorAll('p, li, strong, em, a, h2, h3, h4, ul, ol, blockquote, sub, sup, td, th, tr');
      for (i = list.length - 1; i >= 0; i--) {
        el = list[i];
        if (/^(TD|TH)$/.test(el.tagName)) continue; /* le celle vuote servono alle tabelle */
        if (el.tagName === 'TR') { if (!el.children.length) { el.parentNode.removeChild(el); changed = true; } continue; }
        if (isEmpty(el)) { el.parentNode.removeChild(el); changed = true; }
      }
      list = root.querySelectorAll('p, li, h2, h3, h4, td, th, blockquote');
      for (i = 0; i < list.length; i++) {
        el = list[i];
        while (el.firstChild && (el.firstChild.nodeName === 'BR' || (el.firstChild.nodeType === 3 && !el.firstChild.nodeValue.trim()))) { el.removeChild(el.firstChild); changed = true; }
        while (el.lastChild && (el.lastChild.nodeName === 'BR' || (el.lastChild.nodeType === 3 && !el.lastChild.nodeValue.trim()))) { el.removeChild(el.lastChild); changed = true; }
      }
      list = root.querySelectorAll('br');
      for (i = 0; i < list.length; i++) { /* mai più di 2 <br> di fila */
        p = list[i].previousSibling; n = p && p.previousSibling;
        if (p && p.nodeName === 'BR' && n && n.nodeName === 'BR') { list[i].parentNode.removeChild(list[i]); changed = true; }
      }
    }
    /* spazio iniziale/finale nei blocchi di testo */
    list = root.querySelectorAll('p, li, h2, h3, h4, td, th');
    for (i = 0; i < list.length; i++) {
      if (list[i].firstChild && list[i].firstChild.nodeType === 3) list[i].firstChild.nodeValue = list[i].firstChild.nodeValue.replace(/^\s+/, '');
      if (list[i].lastChild && list[i].lastChild.nodeType === 3) list[i].lastChild.nodeValue = list[i].lastChild.nodeValue.replace(/\s+$/, '');
    }
  }

  /* Frasi spezzate dagli "a capo" fissi del sito di origine: si ricuciono.
     Si unisce quando la riga prima NON finisce una frase e quella dopo continua
     (inizia con minuscola, oppure la prima finisce con virgola o con una parola "di collegamento":
     a, di, con, per, il, la, e...). Righe che finiscono con . ! ? : ; restano separate,
     così gli elenchi scritti con gli a capo ("Cotone 95%<br>Elastan 5%") non si toccano. */
  var LINK_WORDS = ' a ad e ed o od ma di da in con su per tra fra il lo la le gli i un uno una l al allo alla ai agli alle del dello della dei degli delle dal dalla dai dalle nel nello nella nei negli nelle sul sulla sui sulle che si ne non più anche o come se ';
  function endsOpen(t) {
    t = t.replace(/\s+$/, '');
    if (!t || /[.!?\u2026:;)\]"\u00bb\u201d%\u00b0]$/.test(t)) return false;
    if (/,$/.test(t)) return true;
    var w = (t.match(/([^\s]+)$/) || [''])[0].toLowerCase().replace(/^[("'\u00ab\u201c]+/, '');
    return !!w && LINK_WORDS.indexOf(' ' + w + ' ') > -1;
  }
  function startsLower(t) {
    t = t.replace(/^\s+/, '');
    return /^\p{Ll}/u.test(t);
  }
  function joinable(prevText, nextText) {
    prevText = prevText.replace(/\s+$/, '');
    if (!prevText || !nextText.replace(/^\s+/, '')) return false;
    if (/[.!?\u2026:;)\u00bb\u201d]$/.test(prevText)) return false;
    return startsLower(nextText) || endsOpen(prevText);
  }
  function joinBroken(root, doc) {
    var els = root.querySelectorAll('p, li, h2, h3, h4, td, th'), i, el, n, prev, next;
    for (i = 0; i < els.length; i++) { /* 1) <br> singoli in mezzo a una frase */
      el = els[i];
      for (n = el.firstChild; n; ) {
        next = n.nextSibling;
        if (n.nodeName === 'BR' && n.previousSibling && next && n.previousSibling.nodeName !== 'BR' && next.nodeName !== 'BR'
          && joinable(n.previousSibling.textContent, next.textContent)) {
          el.replaceChild(doc.createTextNode(' '), n);
        }
        n = next;
      }
    }
    els = root.querySelectorAll('p'); /* 2) paragrafi consecutivi che sono la stessa frase */
    for (i = 0; i < els.length; i++) {
      el = els[i];
      while ((next = el.nextElementSibling) && next.tagName === 'P' && joinable(el.textContent, next.textContent)) {
        el.appendChild(doc.createTextNode(' '));
        while (next.firstChild) el.appendChild(next.firstChild);
        next.parentNode.removeChild(next);
      }
    }
  }

  /* <p>testo<br><br>altro testo</p>  ->  due paragrafi */
  function splitDoubleBr(root, doc) {
    var ps = root.querySelectorAll('p'), i, j, p, kids, np, br;
    for (i = 0; i < ps.length; i++) {
      p = ps[i];
      for (j = 0; j < p.childNodes.length - 1; j++) {
        if (p.childNodes[j].nodeName === 'BR' && p.childNodes[j + 1].nodeName === 'BR') {
          np = doc.createElement('p');
          while (p.childNodes[j + 2]) np.appendChild(p.childNodes[j + 2]);
          p.removeChild(p.childNodes[j + 1]); p.removeChild(p.childNodes[j]);
          p.parentNode.insertBefore(np, p.nextSibling);
          break;
        }
      }
    }
  }

  function squeeze(root) {
    var w = document.createTreeWalker(root, 4), n, list = [];
    root.normalize();
    while ((n = w.nextNode())) list.push(n);
    list.forEach(function (t) { t.nodeValue = t.nodeValue.replace(/ {2,}/g, ' '); });
  }

  /* Testo "sciolto" al primo livello: lo mette in paragrafi (due <br> di fila = nuovo paragrafo).
     Restituisce un nuovo contenitore. */
  function wrapLoose(root, doc) {
    var res = doc.createElement('div'), kids = Array.prototype.slice.call(root.childNodes), cur = null, i, k;
    function flush() {
      if (cur && (!isEmpty(cur) || cur.querySelector('img'))) res.appendChild(cur);
      cur = null;
    }
    for (i = 0; i < kids.length; i++) {
      k = kids[i];
      if (k.nodeType === 1 && /^(P|UL|OL|H2|H3|H4|TABLE|BLOCKQUOTE)$/.test(k.tagName)) { flush(); res.appendChild(k); continue; }
      if (k.nodeType === 1 && k.tagName === 'BR') {
        if (kids[i + 1] && kids[i + 1].nodeName === 'BR') { flush(); i++; }
        else if (cur) cur.appendChild(doc.createElement('br'));
        continue;
      }
      if (!cur) cur = doc.createElement('p');
      cur.appendChild(k);
    }
    flush();
    return res;
  }

  function cleanRte(el) {
    if (!el || el.getAttribute('data-armonia-rte-done')) return;
    var doc = document, tpl = doc.createElement('template'), out = doc.createDocumentFragment(), holder;
    tpl.innerHTML = el.innerHTML; /* template = inerte: niente script/immagini finché non è pulito */
    holder = doc.createElement('div');
    clean(tpl.content, holder, doc);
    holder = wrapLoose(holder, doc);
    for (var r = 0; r < 4; r++) splitDoubleBr(holder, doc); /* ripetuto: una riga può contenere più 'a capo doppi' */
    tidy(holder);
    joinBroken(holder, doc);
    squeeze(holder);
    tidy(holder);
    while (holder.firstChild) out.appendChild(holder.firstChild);
    el.textContent = '';
    el.appendChild(out);
    el.setAttribute('data-armonia-rte-done', '1');
  }

  function run(root) {
    var list = (root || document).querySelectorAll('[data-armonia-rte]'), i;
    for (i = 0; i < list.length; i++) {
      try { cleanRte(list[i]); } catch (e) { /* se qualcosa va storto resta il testo originale + il reset CSS */ }
    }
  }

  A.cleanRte = cleanRte;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); });
  else run();
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
